var _ = require("underscore");
var cio_datamodel = require("cio-datamodel");
var toSVGutil = require("./toSVGutil");

var drawPathDataTo2D = function (svg, group, data, attrs) {
    console.assert(data instanceof cio_datamodel.PathData);

    var d = svg.createPath();

    if (data.closed())
        d.move(data.objects.get(-1).endpoint().getX(), data.objects.get(-1).endpoint().getY());

    data.objects.forEach(function (index, object) {
        if (object.type() == cio_datamodel.PathType.POINT) {
            d = d.move(object.endpoint().getX(), object.endpoint().getY());
        } else if (object.type() == cio_datamodel.PathType.LINE) {
            d = d.line(object.endpoint().getX(), object.endpoint().getY());
        } else if(object.type() == cio_datamodel.PathType.CURVEC) {
            d = d.curveC(object.tan_0().getX(), object.tan_0().getY(),
                object.tan_1().getX(), object.tan_1().getY(),
                object.endpoint().getX(), object.endpoint().getY());
        } else if(object.type() == cio_datamodel.PathType.ARC) {
            d = d.arc(object.xRadius(), object.yRadius(),
                object.angle(),
                (object.largeArcFlag() ? 1 : 0),
                (object.sweepFlag() ? 1 : 0),
                object.endpoint().getX(), object.endpoint().getY(),
                false);
        } else {
            console.error("Unsupported path object type");
        }
    });

    if (data.closed())
        d = d.close();

    var def_attrs = {
        'stroke-linecap': "round",
    };

    var attrs_total = {};

    _.extend(attrs_total, def_attrs);
    _.extend(attrs_total, toSVGutil.styleToAttributes(data));
    if(attrs) _.extend(attrs_total, attrs);

    return svg.path(group, d, attrs_total);
};

module.exports = drawPathDataTo2D;

